import { getDialogHooks } from 'utilities/dialog-context/dialog-context-helpers';
import {
  TermConsentsDialog,
  TermConsentsDialogCallbackInput,
  TermConsentsDialogUniqueProps,
} from '../term-consents-dialog';

const { useDialogForContext, useDialog: useTermConsentsDialog } =
  getDialogHooks<
    TermConsentsDialogUniqueProps,
    TermConsentsDialogCallbackInput
  >(TermConsentsDialog);

export const useTermConsentsDialogForContext = useDialogForContext;
export default useTermConsentsDialog;
